export const DAYS = ['일', '월', '화', '수', '목', '금', '토'];

export const calendarClassNames = {
  months: 'flex flex-col gap-normal-large',
  month: 'relative w-full pb-tiny-medium',
  button_previous: 'inline-flex items-center absolute top-0',
  month_caption: 'flex items-center justify-center',
  button_next: 'inline-flex items-center absolute top-0 right-0',
  caption_label: 'body-large-semibold',
  month_grid: 'w-full flex flex-col gap-tiny-large',
  weeks: 'flex flex-col gap-tiny-large',
  week: 'flex gap-tiny-large items-center',
  day: 'flex-1 flex justify-center items-center body-medium-semibold text-neutral-foreground-main first:text-bzc-red-600 text-neutral-foreground-main aria-selected:opacity-100 hover:bg-gray-100 focus-visible:bg-gray-100 data-[selected]:bg-blue-600 data-[selected]:text-white data-[today]:bg-gray-100 data-[outside]:text-gray-400 data-[outside]:opacity-50',
  day_button: 'flex-1 body-medium-semibold py-tiny-large hover:bg-blue-200 hover:rounded-bzc-circular',
  day_today: 'bg-neutral-background-hovered&pressed',
  day_hidden: 'invisible'
};

export const calendarFormatters = {
  formatCaption: (date: Date) => `${date.getFullYear()}년 ${date.getMonth() + 1}월`
};
